module.exports = __webpack_public_path__ + "static/img/rotate.1c220fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rotate.png
// module id = 85
// module chunks = 1